/**
 * inspirationOverview
 *
 * Grid für Inspiration Homepage using masonry-Plugin
 * (if more features are needed isotope-Plugin could be used instead easily)
 *
 */

import * as resize from "@sharedJS/resize";

// DOM class/id-names
let copyText;

function init() {
	// DOM
	const $gridContainer = $(".js-inspiration-home-grid");

	// DOM class/id-names
	const itemSelector = ".js-inspiration-home-grid-item";
	const columnWidth = ".js-inspiration-home-grid-sizer";
	const hero = ".js-inspiration-home-hero";

	copyText = ".js-inspiration-home-copy";

	$gridContainer.masonry({
		itemSelector,
		columnWidth,
		stamp: hero,
		percentPosition: true,
	});

	resize.addListener(inspirationOverview);
	setCopyTextCrop();
}

function updateResize() {
	setCopyTextCrop();
}

function setCopyTextCrop() {
	const $copyText = $(copyText);

	$copyText.each(function () {
		const $this = $(this);
		if (this.scrollHeight > $this.height()) {
			$this.addClass("isCropped");
		} else {
			$this.removeClass("isCropped");
		}
	});
}

const inspirationOverview = {
	init,
	updateResize,
};

export default inspirationOverview;
